const tooltips = {
  submitCandidate: "Submit Candidate",
  cvLimitFullTip: "Candidate CV limit reached",
};

export { tooltips as default };
